/** @format */

'use strict';

(function () {
  initCefrLevelModel.$inject = ["cefrLevelJSDataModel"];
  cefrLevel.$inject = ["DS", "$http", "$log"];
  angular.module('sis-components.model.cefrLevel', ['js-data']).factory('cefrLevelJSDataModel', cefrLevel).run(initCefrLevelModel);

  /**
   * @ngInject
   */
  function cefrLevel(DS, $http, $log) {
    var model = DS.defineResource({
      idAttribute: 'urn',
      name: 'cefrLevel',
      endpoint: '/kori/api/cached/codebooks/urn:code:cefr-level',
      watchChanges: false
    });
    model.lazyGetAll = _.once(function () {
      return $http.get(model.endpoint).then(function (response) {
        model.inject(_.values(response.data));
        return model.getAll();
      }).catch(function (error) {
        $log.error(error);
      });
    });
    return model;
  }

  /**
   * @ngInject
   */
  function initCefrLevelModel(cefrLevelJSDataModel) {
    cefrLevelJSDataModel.lazyGetAll();
  }
})();